import { useNavigate } from 'react-router-dom';
import logoText from "../../assets/clapkartel-Icon-updated.png";
import SearchIcon from "../../assets/searchVector.png";
import { useState } from 'react';
import { auth } from '../../firebase';
import { signOut } from 'firebase/auth';
import "./index.css";

const Header = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  /**
   * Handle user logout
   * Clears authentication token and redirects to login page
   */
  const handleLogout = () => {
    // Fire Firebase signOut in background (no await to prevent hanging UI)
    try {
      signOut(auth);
    } catch (_) { }

    // Clear all storage mechanisms to prevent session leakage
    localStorage.clear();
    sessionStorage.clear();

    // Force a full browser reload/replace on the current tab to destroy react memory
    window.location.replace(window.location.origin + '/login');
  };

  /**
   * Handle search - Navigate to users page with search query
   */
  const handleSearch = () => {
    navigate('/users', {
      state: { searchQuery: searchQuery.trim() }
    });
  };

  /**
   * Handle Enter key press in search input
   */
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="header-container">
      <img
        src={logoText}
        alt="logoText"
        className="header-logo"
        onClick={() => navigate('/')}
      />
      <div className="header-search-wrapper" onClick={handleSearch}>
        <input
          type="text"
          className="header-search-input"
          placeholder="Search For Cast & Crew, Directory, 24 Crafts & More"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <img
          src={SearchIcon}
          alt="searchVector"
          className="header-search-icon"
          onClick={handleSearch}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <button
        className="header-logout-button"
        onClick={handleLogout}
      >
        Logout
      </button>
    </div>
  );
};

export default Header;